import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30196022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[25px] tw-self-stretch tw-p-[40px] tw-bg-[#FFFFFF]" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-[10px] headingWrapper" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-[10px] tw-w-full" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[16px] tw-not-italic tw-font-semibold tw-leading-[100%]" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 -9.53674e-07C6.41775 -9.53674e-07 4.87104 0.469191 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34314C12.1566 0.842854 10.1217 -9.53674e-07 8 -9.53674e-07ZM8.16667 3.33333C8.36445 3.33333 8.55779 3.39198 8.72224 3.50186C8.88669 3.61174 9.01486 3.76792 9.09055 3.95065C9.16624 4.13337 9.18604 4.33444 9.14746 4.52842C9.10887 4.7224 9.01363 4.90059 8.87378 5.04044C8.73392 5.18029 8.55574 5.27553 8.36176 5.31412C8.16778 5.3527 7.96671 5.3329 7.78399 5.25721C7.60126 5.18152 7.44508 5.05335 7.3352 4.8889C7.22532 4.72445 7.16667 4.53111 7.16667 4.33333C7.16667 4.06812 7.27203 3.81376 7.45956 3.62623C7.6471 3.43869 7.90145 3.33333 8.16667 3.33333ZM9.66667 12.3333H7C6.82319 12.3333 6.65362 12.2631 6.5286 12.1381C6.40358 12.013 6.33334 11.8435 6.33334 11.6667C6.33334 11.4899 6.40358 11.3203 6.5286 11.1953C6.65362 11.0702 6.82319 11 7 11H7.5C7.54421 11 7.5866 10.9824 7.61786 10.9512C7.64911 10.9199 7.66667 10.8775 7.66667 10.8333V7.83333C7.66667 7.78913 7.64911 7.74674 7.61786 7.71548C7.5866 7.68422 7.54421 7.66667 7.5 7.66667H7C6.82319 7.66667 6.65362 7.59643 6.5286 7.4714C6.40358 7.34638 6.33334 7.17681 6.33334 7C6.33334 6.82319 6.40358 6.65362 6.5286 6.52859C6.65362 6.40357 6.82319 6.33333 7 6.33333H7.66667C8.02029 6.33333 8.35943 6.47381 8.60948 6.72386C8.85953 6.97391 9 7.31304 9 7.66667V10.8333C9 10.8775 9.01756 10.9199 9.04882 10.9512C9.08008 10.9824 9.12247 11 9.16667 11H9.66667C9.84348 11 10.0131 11.0702 10.1381 11.1953C10.2631 11.3203 10.3333 11.4899 10.3333 11.6667C10.3333 11.8435 10.2631 12.013 10.1381 12.1381C10.0131 12.2631 9.84348 12.3333 9.66667 12.3333Z",
    fill: "#DBDBDB"
  })
], -1))
const _hoisted_6 = { class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_7 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[25px]" }
const _hoisted_8 = { class: "tw-flex tw-flex-col tw-justify-between md:tw-items-start tw-gap-[25px] tw-self-stretch tw-rounded-[4px] main" }
const _hoisted_9 = {
  key: 0,
  class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
}
const _hoisted_10 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px]" }
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[545px] tw-relative" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 1,
  class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
}
const _hoisted_14 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px]" }
const _hoisted_15 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[545px] tw-relative" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "tw-flex tw-flex-row tw-justify-end tw-items-center tw-w-full tw-mt-[15px]" }

import { ref, watch, onMounted, PropType } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { IChecklistRequested } from "@/interfaces/vendor";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorUpdateAssessmentDetailModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  checklistAssessmentData: {
    type: Object as PropType<IChecklistRequested>,
    required: true,
  },
},
  emits: ["update:show", "resetModalHistory"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
const notesExternal = ref(props.checklistAssessmentData.notesExternal || "");
const descExternal: any = ref(props.checklistAssessmentData.descExternal || "");
const autoTextareaDes: any = ref(null);
const autoTextareaNotes: any = ref(null);

const autoResize = () => {
  if (autoTextareaDes.value) {
    autoTextareaDes.value.style.height = "auto";
    autoTextareaDes.value.style.height =
      autoTextareaDes.value.scrollHeight + "px";
  }

  if (autoTextareaNotes.value) {
    autoTextareaNotes.value.style.height = "auto";
    autoTextareaNotes.value.style.height =
      autoTextareaNotes.value.scrollHeight + "px";
  }
};

onMounted(() => {
  autoResize();
});


const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]",
    visible: _unref(showRef),
    "border-radius": "4px",
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: _normalizeClass(`modal-header`),
        title: 
        _unref(getComponentUiText)(
          'app-component-vendor-assessment-update-detail-modal-title-1',
        )
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
                "app-component-vendor-assessment-update-detail-modal-body-title-1",
              )), 1),
            _hoisted_5
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
              "app-component-vendor-assessment-update-detail-modal-body-sub-title-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (descExternal.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-vendor-assessment-update-detail-modal-field-description-1",
                )), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "autoTextareaDes",
                      ref: autoTextareaDes,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((descExternal).value = $event)),
                      disabled: true,
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-create-assessment-modal-field-placeholder-name-1',
                  )
                ,
                      style: `outline-color : #EFF0F1`,
                      class: "auto-expand tw-min-h-[82px] tw-text-[15px] tw-font-normal tw-leading-none tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
                    }, null, 8, _hoisted_12), [
                      [_vModelText, descExternal.value]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (notesExternal.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-vendor-assessment-update-detail-modal-field-notes-1",
                )), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "autoTextareaNotes",
                      ref: autoTextareaNotes,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notesExternal).value = $event)),
                      disabled: true,
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-create-assessment-modal-field-placeholder-description-1',
                  )
                ,
                      style: `outline-color : #EFF0F1`,
                      class: "auto-expand tw-min-h-[82px] tw-text-[15px] tw-font-normal tw-leading-none tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]"
                    }, null, 8, _hoisted_16), [
                      [_vModelText, notesExternal.value]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_b_button, {
            style: {"line-height":"100%","height":"36px"},
            variant: "primary",
            class: "tw-w-fit tw-shadow-none tw-bg-[#387DFF] tw-text-[#FFFFFF] tw-px-[18px] tw-text-[13px] tw-font-medium tw-rounded-[100px]",
            type: "submit",
            onClick: handleCloseModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-component-vendor-assessment-update-detail-modal-close-button-1",
            )), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})